import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const Hero = styled.section`
  position: relative;
  overflow: hidden;
  padding-top: 60px;
  padding-bottom: 60px;

  ${maxMediaQueries.phablet`
    padding: 0;
  `};

  /* Imagen de fondo como <img> real: el preload scanner la descubre en el HTML
     (antes de parsear el CSS) → LCP más rápido que un background-image, y además
     es indexable y accesible (alt). */
  .hero-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;

    @media (min-width: 1800px) {
      object-position: center center;
    }

    ${maxMediaQueries.phone`
      object-position: top right;
    `};
  }

  /* Capa oscura para la legibilidad del texto en tablet/móvil
     (sustituye al background-color + background-blend-mode: darken anterior). */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    pointer-events: none;

    @media (max-width: 900px) {
      background: rgba(0, 0, 0, 0.2);
    }

    ${maxMediaQueries.phone`
      background: rgba(0, 0, 0, 0.4);
    `};
  }
`;
